<div class="row mb-2">
  <div class="col-md-2">
    <select class="form-control">
      <option value="">Select Search By</option>
      <option value="userName">User Name</option>
      <option value="phoneNumber">Mobile Number</option>
    </select>
  </div>
  <div class="col-md-2">
    <input type="search" class="form-control mb-2" placeholder="Search Text" />
  </div>
  <div class="col-md-2">
    <button class="btn btn-primary btn-block">
      Search <i class="fa fa-search"></i>
    </button>
  </div>

  <div class="col-md-6 m-0 text-end">
    <button
      style="margin: 0px 5px 0px 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
      (click)="exportTableToExcel('Current-Deposite-Transactions')"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <button
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
      (click)="getAllDepositeTransactionData()"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All To Excel
    </button>
  </div>
</div>

<div class="card shadow-sm">
  <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="mb-0">Transaction History</h5>
    <div>
      <!-- Export to Excel Button -->
      <!-- <button class="btn btn-light btn-sm me-2">Export Current Page</button> -->
      <!-- Export All to Excel Button -->
      <!-- <button class="btn btn-light btn-sm">Export All to Excel</button> -->
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table
        class="table table-bordered table-hover mb-0"
        id="depositeTransactionTable"
      >
        <thead class="table-light">
          <tr>
            <th>Date</th>
            <th>User Name</th>
            <th>User Mobile</th>
            <th>Payment Order ID</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="fw-bold" *ngFor="let data of depositesTransactions">
            <td>
              {{
                data.timestamp * 1000 | date : "dd MMM yyyy hh:mm a" : "en-IN"
              }}
            </td>
            <td>{{ data.userName }}</td>
            <td>{{ data.phoneNumber }}</td>
            <td>{{ data.paymentOrderId }}</td>
            <td class="">
              {{ data.amount }}
            </td>
            <td>
              <span
                class="badge rounded-pill"
                [ngClass]="{
                  ' bg-info': data.status === 0,
                  ' bg-success': data.status === 1,
                  ' bg-primary': data.status === 2,
                  ' bg-danger': data.status === 3,
                  ' bg-warning': data.status === ''
                }"
                >{{
                  data.status === 0
                    ? "Pending"
                    : data.status === 1
                    ? "Success"
                    : data.status === 2
                    ? "Partial Payment"
                    : data.status === 3
                    ? "Failed"
                    : ""
                }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>
